"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ChevronRight } from "lucide-react";
export default function AboutRestaurant() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="256075" id="il-nostro-metodo" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {}
        <div className="flex flex-col items-center mb-12 md:mb-16">
          <img src="/img/navis_brokerage_logo.png" alt="NAVIS Logo" className="h-12 md:h-14 mb-6" loading="lazy" decoding="async" />
          <h1 className="font-default text-3xl md:text-5xl lg:text-6xl font-bold text-center tracking-tight" style={{
          color: "var(--foreground)"
        }}>
            Il Nostro Metodo
          </h1>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <p className="font-default text-foreground text-base md:text-lg leading-relaxed">
                Il nostro approccio alla mediazione marittima si fonda su una rigorosa analisi tecnica e una profonda conoscenza del mercato globale. Ogni yacht che entra nella nostra collezione viene sottoposto a uno screening meticoloso per garantire standard di eccellenza assoluti ai nostri armatori.
              </p>

              <p className="font-default text-foreground text-base md:text-lg leading-relaxed">
                Operiamo con una visione strategica che unisce la logistica internazionale alla massima discrezione. La nostra missione è trasformare la complessità dell'acquisizione nautica in un percorso fluido, trasparente e tecnicamente ineccepibile per ogni cliente Elite.
              </p>

              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--secondary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Analisi Tecnica: Valutazioni strutturali e perizie certificate
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--secondary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Logistica: Gestione completa dei trasferimenti e pratiche doganali
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-lg mt-1 shrink-0" style={{
                  color: "var(--secondary)"
                }}>
                    •
                  </span>
                  <p className="font-default text-foreground text-sm md:text-base">
                    Privacy: Protocolli di riservatezza per transazioni di alto profilo
                  </p>
                </div>
              </div>

              <Link to="/CollectionGoldPage">
                <Button variant="outline" className="mt-6 text-primary border-primary hover:bg-primary/10 rounded-md">
                  Scopri la Collezione Gold
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-700 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/broker_inspecting_yacht_deck.png" alt="Broker NAVIS ispeziona il ponte di uno yacht" className="w-full h-auto rounded-md shadow-lg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/broker_inspecting_yacht_deck.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/broker_inspecting_yacht_deck.png-wvc-sizes" loading="lazy" decoding="async" />
              <div className="absolute inset-0 rounded-md border-2 -z-10 translate-x-4 translate-y-4" style={{
              borderColor: "var(--secondary)"
            }} />
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-24 pt-12 md:pt-16 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--secondary)"
            }}>
                15+
              </h3>
              <p className="font-default text-foreground text-sm md:text-base">
                Anni di Esperienza Tecnica
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--secondary)"
            }}>
                120+
              </h3>
              <p className="font-default text-foreground text-sm md:text-base">
                Yacht Selezionati Elite
              </p>
            </div>
            <div className="text-center">
              <h3 className="font-default text-2xl md:text-3xl font-bold mb-2" style={{
              color: "var(--secondary)"
            }}>
                24h
              </h3>
              <p className="font-default text-foreground text-sm md:text-base">
                Risposta Consulenziale
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}